import { queryOptions } from "@tanstack/react-query";
import { createServerFn } from "@tanstack/react-start";
import { getApiClient, getSessionCookieHeader } from "~/utils/api-client";

export const MANAGER_REPORTEES_KEYS = {
	all: ["manager-reportees"] as const,
	self: () => [...MANAGER_REPORTEES_KEYS.all, "self"] as const,
	amountOfRequests: () =>
		[...MANAGER_REPORTEES_KEYS.all, "amount-of-requests"] as const,
};

/**
 * Get manager and reportees for the current authenticated user
 */
const managerReporteesQueryOptions = queryOptions({
	queryKey: MANAGER_REPORTEES_KEYS.self(),
	queryFn: () => fetchManagerReportees(),
	// Cache for 5 minutes - manager-reportee relationships don't change often
	staleTime: 5 * 60 * 1000,
	// Keep in cache even when unused
	gcTime: 10 * 60 * 1000,
});

const fetchManagerReportees = createServerFn({ method: "GET" }).handler(
	async () => {
		const api_client = getApiClient(getSessionCookieHeader());

		const result = await api_client.self.api["manager-reportees"].$get();

		if (!result.ok) {
			throw new Error("Failed to fetch manager and reportees");
		}

		return await result.json();
	},
);

export { managerReporteesQueryOptions };

const amountOfRequestsQueryOptions = queryOptions({
	queryKey: MANAGER_REPORTEES_KEYS.amountOfRequests(),
	queryFn: () => fetchAmountOfRequests(),
});

const fetchAmountOfRequests = createServerFn({ method: "GET" }).handler(
	async () => {
		const api_client = getApiClient(getSessionCookieHeader());

		const result =
			await api_client.self.api["leave-requests"].reportees.count.$get();

		if (!result.ok) {
			throw new Error("Failed to fetch amount of requests");
		}

		return await result.json();
	},
);

export { amountOfRequestsQueryOptions };
